var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificacionesFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ico / Bottom Nav / large / notificaciones-full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico-/-Bottom-Nav-/-large-/-notificaciones-full",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.24234451,15.005 L18.2423445,15.005 L18.2423445,13.005 L6.24234451,13.005 L6.24234451,15.005 Z M21.4403445,19.397 L19.2463445,16.007 L19.2423445,16.007 L19.2423445,13.005 L19.2423445,12.777 L19.2423445,11.79 C19.2423445,8.673 17.4983445,5.747 14.8493445,4.563 C14.8223445,3.146 13.6653445,2 12.2423445,2 C10.8443445,2 9.70834451,3.108 9.64334451,4.49 C6.92334451,5.551 5.24234451,8.26 5.24234451,11.481 L5.24234451,12.817 L5.24234451,13.005 L5.24234451,16.007 L5.24234451,16.009 L3.04534451,19.404 C2.90434451,19.685 3.10934451,20.016 3.42334451,20.016 L9.71234451,20.013 C9.99034451,21.155 11.0163445,22.009 12.2413445,22.009 C13.4703445,22.009 14.4953445,21.154 14.7733445,20.011 L21.0623445,20.008 C21.3763445,20.008 21.5803445,19.678 21.4403445,19.397 L21.4403445,19.397 Z",
    id: "Fill-1",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificacionesFull);
export default __webpack_public_path__ + "static/media/notificaciones-full.ca6f4e698ff4141829bc049e2ced6421.svg";
export { ForwardRef as ReactComponent };